import { render } from "./Burger.vue?vue&type=template&id=49dbea15"
import script from "./Burger.vue?vue&type=script&lang=js"
export * from "./Burger.vue?vue&type=script&lang=js"

import "./Burger.vue?vue&type=style&index=0&id=49dbea15&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__